import { render } from "./AposInputRelationship.vue?vue&type=template&id=568d8e72&scoped=true"
import script from "./AposInputRelationship.vue?vue&type=script&lang=js"
export * from "./AposInputRelationship.vue?vue&type=script&lang=js"

import "./AposInputRelationship.vue?vue&type=style&index=0&id=568d8e72&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568d8e72"],['__file',"schema/ui/apos/components/AposInputRelationship.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "568d8e72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('568d8e72', __exports__)) {
    api.reload('568d8e72', __exports__)
  }
  
  module.hot.accept("./AposInputRelationship.vue?vue&type=template&id=568d8e72&scoped=true", () => {
    api.rerender('568d8e72', render)
  })

}


export default __exports__